import memoize from 'lru-memoize';
import React from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {stringHasCssUrl} from '../../../../../libs/shared/core/src/helpers/utilities/stringHelpers';
import {MessageTypesEnum} from '../../../../../libs/shared/core/src/models/api/commonMessageModel';
import {
  MessageModel,
  MessageVisualStatusesEnum,
} from '../../../../../libs/shared/core/src/models/api/messageModel';

export const messageBodyHasExternalContent = memoize()(
  (message: MessageModel) =>
    message.visualStatus === MessageVisualStatusesEnum.TIMELINE &&
    message.type === MessageTypesEnum.EMAIL &&
    (/<img\s/i.test(message.body) || stringHasCssUrl(message.body)),
);

export function renderReplyTextForMessageType(messageType: MessageTypesEnum): React.ReactNode {
  switch (messageType) {
    case MessageTypesEnum.SMS:
      return <Trans id="message-reply-sms">Reply to SMS</Trans>;
    case MessageTypesEnum.TWEET:
      return <Trans id="message-reply-tweet">Reply to post</Trans>;
    case MessageTypesEnum.TWEET_DM:
      return <Trans id="message-reply-dm">Reply to DM</Trans>;
    case MessageTypesEnum.GOOGLE_PLAY:
      return <Trans id="message-reply-review">Reply to review</Trans>;
    default:
      return <Trans id="message-reply">Reply</Trans>;
  }
}
